export class UserSimilaritiesListView {
    id: number;
    email: string;
    status: number;
    firstName: string;
    lastName: string;
    registrationDate: Date | null;
    expertRoleLevel: number;
    login: string;
    userGroupId: number;
    affiliationCode: string;
    company: CompanyView;

    constructor(data?: any) {
        this.id = data?.id || -1;
        this.email = data?.email || '';
        this.status = data?.status || -1;
        this.firstName = data?.firstName || '';
        this.lastName = data?.lastName || '';
        this.registrationDate = data?.registrationDate ? new Date(data.registrationDate) : null;
        this.expertRoleLevel = data?.expertRoleLevel || -1;
        this.login = data?.login || '';
        this.userGroupId = data?.userGroupId || -1;
        this.affiliationCode = data?.affiliationCode || '';
        this.company = data?.company ? new CompanyView(data.company) : new CompanyView();
    }
}

class CompanyView {
    name: string;
    telNumber: string;
    vatNumber: string;

    constructor(data?: any) {
        this.name = data?.name || '';
        this.telNumber = data?.telNumber || '';
        this.vatNumber = data?.vatNumber || '';
    }
}